export const hist = new Map();

export function pushHist(k, ltp) {
  if (ltp == null) return;
  const a = hist.get(k) || [];
  if (a[a.length - 1] === ltp) return;
  a.push(ltp);
  if (a.length > 25) a.shift();
  hist.set(k, a);
}
